export const management =[
  {
    "name": "XXX 品牌消费者忠诚度影响因素及营销策略优化研究",
    "desc": "消费市场与品牌策略",
    "path": " "
  },
  {
    "name": "新生代群体对 XXX 产品线上消费决策行为与平台运营策略调研分析",
    "desc": "消费市场与品牌策略",
    "path": " "
  },
  {
    "name": "性价比导向下 XXX 产品选购偏好及市场推广策略研究",
    "desc": "消费市场与品牌策略",
    "path": " "
  },
  {
    "name": "XXX 网红产品生命周期及长效运营策略 —— 基于消费者调研数据",
    "desc": "消费市场与品牌策略",
    "path": " "
  },
  {
    "name": "包装设计对 XXX 产品消费者购买意愿的影响及产品优化策略分析",
    "desc": "消费市场与品牌策略",
    "path": " "
  },
  {
    "name": "XXX 品牌售后服务体验对复购率的作用机制及服务升级策略研究",
    "desc": "消费市场与品牌策略",
    "path": " "
  },
  {
    "name": "XXX 国潮品牌认知度、接受度与发展策略实证调研",
    "desc": "消费市场与品牌策略",
    "path": " "
  },
  {
    "name": "XXX 生鲜零售消费习惯及门店布局、配送服务优化策略研究",
    "desc": "消费市场与品牌策略",
    "path": " "
  },
  {
    "name": "价格敏感度对 XXX 产品消费选择的影响及差异化定价策略调研",
    "desc": "消费市场与品牌策略",
    "path": " "
  },
  {
    "name": "XXX 二手商品消费动机、行为特征及行业规范发展策略分析",
    "desc": "消费市场与品牌策略",
    "path": " "
  },
  {
    "name": "XXX 直播电商用户观看、下单行为及主播运营策略优化研究",
    "desc": "数字经济与电商运营策略",
    "path": " "
  },
  {
    "name": "XXX 短视频带货转化效果影响因素及内容创作策略实证分析",
    "desc": "数字经济与电商运营策略",
    "path": " "
  },
  {
    "name": "XXX 社区团购用户使用体验、痛点及平台发展策略调研",
    "desc": "数字经济与电商运营策略",
    "path": " "
  },
  {
    "name": "XXX 私域流量运营现状、效果评估及长效增长策略研究",
    "desc": "数字经济与电商运营策略",
    "path": " "
  },
  {
    "name": "XXX 中小企业数字化转型现状、困境及落地策略调研分析",
    "desc": "数字经济与电商运营策略",
    "path": " "
  },
  {
    "name": "XXX 线上店铺流量来源分析及引流推广优化策略实证研究",
    "desc": "数字经济与电商运营策略",
    "path": " "
  },
  {
    "name": "XXX 移动支付使用场景、安全感知及行业发展策略调研",
    "desc": "数字经济与电商运营策略",
    "path": " "
  },
  {
    "name": "XXX 电商平台隐私政策感知对用户留存的影响及合规策略",
    "desc": "数字经济与电商运营策略",
    "path": " "
  },
  {
    "name": "XXX 跨境电商消费者顾虑及商家风控、营销策略研究",
    "desc": "数字经济与电商运营策略",
    "path": " "
  },
  {
    "name": "XXX 虚拟数字人应用接受度及商业落地推广策略调研",
    "desc": "数字经济与电商运营策略",
    "path": " "
  },
  {
    "name": "XXX 企业员工工作满意度影响因素及人力管理优化策略研究",
    "desc": "人力资源与企业管理策略",
    "path": " "
  },
  {
    "name": "XXX 企业新生代员工离职倾向成因及留人激励策略实证调研",
    "desc": "人力资源与企业管理策略",
    "path": " "
  },
  {
    "name": "XXX 企业职场培训效果评价体系及培训体系优化策略分析",
    "desc": "人力资源与企业管理策略",
    "path": " "
  },
  {
    "name": "XXX 团队沟通效率影响因素及团队管理改进策略调研",
    "desc": "人力资源与企业管理策略",
    "path": " "
  },
  {
    "name": "XXX 企业远程办公工作效率、体验及管理适配策略研究",
    "desc": "人力资源与企业管理策略",
    "path": " "
  },
  {
    "name": "XXX 企业员工职业倦怠现状、诱因及干预缓解策略实证分析",
    "desc": "人力资源与企业管理策略",
    "path": " "
  },
  {
    "name": "XXX 企业绩效考核制度认可度及考核体系优化策略调研",
    "desc": "人力资源与企业管理策略",
    "path": " "
  },
  {
    "name": "XXX 企业职场晋升公平感对工作积极性的影响及管理策略",
    "desc": "人力资源与企业管理策略",
    "path": " "
  },
  {
    "name": "XXX 企业文化认同度现状及文化落地建设策略研究",
    "desc": "人力资源与企业管理策略",
    "path": " "
  },
  {
    "name": "XXX 灵活用工模式从业者诉求及企业用工管理策略分析",
    "desc": "人力资源与企业管理策略",
    "path": " "
  },
  {
    "name": "XXX 区域城市居民周边游出行偏好及文旅产品开发策略调研",
    "desc": "文旅产业与休闲服务策略",
    "path": " "
  },
  {
    "name": "XXX 景区游客体验评价及服务、设施升级优化策略研究",
    "desc": "文旅产业与休闲服务策略",
    "path": " "
  },
  {
    "name": "XXX 民宿行业游客选择偏好及经营提升策略实证分析",
    "desc": "文旅产业与休闲服务策略",
    "path": " "
  },
  {
    "name": "XXX 文化旅游目的地品牌形象感知及宣传推广策略调研",
    "desc": "文旅产业与休闲服务策略",
    "path": " "
  },
  {
    "name": "XXX 区域夜间文旅消费行为特征及业态布局发展策略研究",
    "desc": "文旅产业与休闲服务策略",
    "path": " "
  },
  {
    "name": "XXX 研学旅行家长、学生双重诉求及产品设计策略分析",
    "desc": "文旅产业与休闲服务策略",
    "path": " "
  },
  {
    "name": "XXX 户外休闲运动参与意愿及配套产业发展策略调研",
    "desc": "文旅产业与休闲服务策略",
    "path": " "
  },
  {
    "name": "XXX 非遗文旅产品消费意愿及市场化推广策略实证研究",
    "desc": "文旅产业与休闲服务策略",
    "path": " "
  },
  {
    "name": "XXX 旅游出行安全感知对出行选择的影响及保障策略",
    "desc": "文旅产业与休闲服务策略",
    "path": " "
  },
  {
    "name": "XXX 区域老年群体旅游需求特征及适老化文旅服务策略分析",
    "desc": "文旅产业与休闲服务策略",
    "path": " "
  },
  {
    "name": "XXX 学校中小学生课后服务满意度及课程优化设置策略调研",
    "desc": "教育行业与校园发展策略",
    "path": " "
  },
  {
    "name": "XXX 机构校外教育培训选择动机及行业发展策略研究",
    "desc": "教育行业与校园发展策略",
    "path": " "
  },
  {
    "name": "XXX 院校大学生线上学习体验、学习效果及教学优化策略分析",
    "desc": "教育行业与校园发展策略",
    "path": " "
  },
  {
    "name": "XXX 高校学生就业焦虑现状、成因及就业指导策略调研",
    "desc": "教育行业与校园发展策略",
    "path": " "
  },
  {
    "name": "XXX 校园食堂服务满意度及后勤管理优化策略实证研究",
    "desc": "教育行业与校园发展策略",
    "path": " "
  },
  {
    "name": "XXX 院校大学生社团参与现状、价值感知及社团运营策略",
    "desc": "教育行业与校园发展策略",
    "path": " "
  },
  {
    "name": "XXX 中职院校学生学习动力影响因素及教学激励策略研究",
    "desc": "教育行业与校园发展策略",
    "path": " "
  },
  {
    "name": "XXX 学校教师职业压力现状及人文关怀策略调研分析",
    "desc": "教育行业与校园发展策略",
    "path": " "
  },
  {
    "name": "XXX 校园垃圾分类执行现状及宣传引导策略实证研究",
    "desc": "教育行业与校园发展策略",
    "path": " "
  },
  {
    "name": "XXX 院校学生体育锻炼习惯养成因素及校园体育推广策略",
    "desc": "教育行业与校园发展策略",
    "path": " "
  },
  {
    "name": "XXX 地区特色农产品销路现状及电商助农推广策略调研",
    "desc": "乡村发展与农业产业策略",
    "path": " "
  },
  {
    "name": "XXX 乡村旅游游客体验及文旅提质发展策略研究",
    "desc": "乡村发展与农业产业策略",
    "path": " "
  },
  {
    "name": "XXX 区域农户农业技术接受意愿及农技推广落地策略分析",
    "desc": "乡村发展与农业产业策略",
    "path": " "
  },
  {
    "name": "XXX 乡村人居环境整治满意度及长效管护策略实证调研",
    "desc": "乡村发展与农业产业策略",
    "path": " "
  },
  {
    "name": "XXX 地区返乡创业人员发展困境及地方扶持优化策略研究",
    "desc": "乡村发展与农业产业策略",
    "path": " "
  },
  {
    "name": "XXX 农村电商使用现状、痛点及技能培训策略调研分析",
    "desc": "乡村发展与农业产业策略",
    "path": " "
  },
  {
    "name": "XXX 区域粮食种植户生产意愿及惠农政策落地优化策略",
    "desc": "乡村发展与农业产业策略",
    "path": " "
  },
  {
    "name": "XXX 乡村民俗文化传承现状及活化发展策略实证研究",
    "desc": "乡村发展与农业产业策略",
    "path": " "
  },
  {
    "name": "XXX 农村养老服务需求现状及养老体系建设策略调研",
    "desc": "乡村发展与农业产业策略",
    "path": " "
  },
  {
    "name": "XXX 乡村集体产业发展现状及运营管理提升策略分析",
    "desc": "乡村发展与农业产业策略",
    "path": " "
  },
  {
    "name": "XXX 餐饮门店顾客满意度影响因素及经营优化策略调研",
    "desc": "餐饮、住宿与生活服务策略",
    "path": " "
  },
  {
    "name": "XXX 外卖消费评价、用餐体验及平台、商家改进策略研究",
    "desc": "餐饮、住宿与生活服务策略",
    "path": " "
  },
  {
    "name": "XXX 特色餐饮品牌传播效果及线下拓店发展策略分析",
    "desc": "餐饮、住宿与生活服务策略",
    "path": " "
  },
  {
    "name": "XXX 酒店入住体验评价及服务、设施升级策略实证调研",
    "desc": "餐饮、住宿与生活服务策略",
    "path": " "
  },
  {
    "name": "XXX 区域早餐消费习惯、需求特征及门店经营布局策略研究",
    "desc": "餐饮、住宿与生活服务策略",
    "path": " "
  },
  {
    "name": "XXX 茶饮品牌消费者复购因素及产品迭代策略调研分析",
    "desc": "餐饮、住宿与生活服务策略",
    "path": " "
  },
  {
    "name": "XXX 家政服务用户需求、评价及行业规范化发展策略",
    "desc": "餐饮、住宿与生活服务策略",
    "path": " "
  },
  {
    "name": "XXX 社区洗车、汽修服务体验及业态优化策略研究",
    "desc": "餐饮、住宿与生活服务策略",
    "path": " "
  },
  {
    "name": "XXX 自助服务设备使用体验及场景布局策略实证分析",
    "desc": "餐饮、住宿与生活服务策略",
    "path": " "
  },
  {
    "name": "XXX 聚餐消费选择偏好及餐饮场景定制化服务策略",
    "desc": "餐饮、住宿与生活服务策略",
    "path": " "
  },
  {
    "name": "XXX 社区服务满意度及社区治理优化策略调研分析",
    "desc": "公共管理、社会服务与环境治理策略",
    "path": " "
  },
  {
    "name": "XXX 城市公共交通出行体验及线路、服务优化策略研究",
    "desc": "公共管理、社会服务与环境治理策略",
    "path": " "
  },
  {
    "name": "XXX 市民垃圾分类认知、执行情况及宣传引导策略实证",
    "desc": "公共管理、社会服务与环境治理策略",
    "path": " "
  },
  {
    "name": "XXX 老旧小区改造居民满意度及后续管理策略调研分析",
    "desc": "公共管理、社会服务与环境治理策略",
    "path": " "
  },
  {
    "name": "XXX 区域公众公共安全感知及安全防控宣传策略研究",
    "desc": "公共管理、社会服务与环境治理策略",
    "path": " "
  },
  {
    "name": "XXX 社区养老服务使用意愿、诉求及服务完善策略调研",
    "desc": "公共管理、社会服务与环境治理策略",
    "path": " "
  },
  {
    "name": "XXX 城市共享单车使用乱象及规范化管理策略实证分析",
    "desc": "公共管理、社会服务与环境治理策略",
    "path": " "
  },
  {
    "name": "XXX 公众低碳生活认知、行为及绿色生活推广策略研究",
    "desc": "公共管理、社会服务与环境治理策略",
    "path": " "
  },
  {
    "name": "XXX 线上政务服务使用体验及便民优化策略调研分析",
    "desc": "公共管理、社会服务与环境治理策略",
    "path": " "
  },
  {
    "name": "XXX 区域流动人口城市融入现状、诉求及公共服务配套策略",
    "desc": "公共管理、社会服务与环境治理策略",
    "path": " "
  }
]